import { z } from 'zod';
import {
    type ControlSocketKind,
    type NodeSocketCfg,
} from './base-node';
import { baseConnectionCfgSchema, connectionNodeConfigSchema } from './connection.zod';

export const torqueToolCommanderNodeCfgSchema = connectionNodeConfigSchema(baseConnectionCfgSchema.extend({
    kind: z.literal('torqueToolCommander'),
    controlValues: baseConnectionCfgSchema.shape.controlValues.merge(z.object({
        command: z.enum([ 'setBatch', 'setVin', 'setPSetId' ]),
    })),
}));
export interface TorqueToolCommanderCfgSchema extends z.infer<typeof torqueToolCommanderNodeCfgSchema> {}

export const torqueToolCommanderNodeSocketCfg = {
    controlSockets: {
        outputs: () => {
            const ret: Record<'next', ControlSocketKind> = {
                next: 'event',
            };
            return ret;
        },
        inputs: () => {
            const ret: Record<'writeData', ControlSocketKind> = {
                writeData: 'event',
            };
            return ret;
        },
    },
    dataSockets: {
        outputs: () => {
            const ret = {};
            return ret;
        },
        inputs: nodeCfg => {
            if (nodeCfg.controlValues.command === 'setBatch') {
                return {
                    pSetId: 'number',
                    batchCount: 'number',
                };
            } else if (nodeCfg.controlValues.command === 'setPSetId') {
                return {
                    pSetId: 'number',
                };
            } else if (nodeCfg.controlValues.command === 'setVin') {
                return {
                    vin: 'string',
                };
            } else {
                const u: never = nodeCfg.controlValues.command;
                throw new Error(`Unknown torque tool command: "${u}"`);
            }
        },
    },
} satisfies NodeSocketCfg<TorqueToolCommanderCfgSchema>;
